import { Box, Text } from '@chakra-ui/react';

import Button from '../../../../../components/ui/buttons/Button';

type DelistSuccessStepProps = {
  onDone: () => void;
  isDelistToBuyout: boolean;
};

const DelistSuccessStep = ({ onDone, isDelistToBuyout }: DelistSuccessStepProps) => (
  <Box px={{ base: '24px', md: '32px' }} pb={{ base: '24px', md: '32px' }} pt="16px">
    <Text fontSize="14px" color="gray.600" lineHeight="1.6" mb="24px">
      {isDelistToBuyout
        ? "Your listing has been removed, and we've moved you back to your lease buyout. Our team will reach out to walk you through your next steps."
        : "Your listing has been removed from the marketplace and buyers can no longer see it. Relisting isn't self-serve, so contact your Lease End reps if you'd like to list your vehicle again."}
    </Text>
    <Button
      w="100%"
      variant="bluePill"
      onClick={onDone}
      trackClick="marketplace_delist_success_done"
      fontWeight="800"
      fontSize="13px"
    >
      Done
    </Button>
  </Box>
);

export default DelistSuccessStep;
